import { useEffect, useState } from 'react';

import { useSearchParams } from 'react-router-dom';

const queryKeys = {
	handle: 'handle',
	wgc: 'wgc',
	version: 'version',
	firstName: 'firstName',
	lastName: 'lastName',
	emailAddress: 'emailAddress',
	mobileNumber: 'mobileNumber',
};

export type TestPayerParams = {
	firstName: string;
	lastName: string;
	emailAddress: string;
	mobileNumber: string;
};

export const useQueryParams = () => {
	const [info, setInfo] = useState<{
		isWidget: boolean;
		isIframe: boolean;
		handle: string;
		wgc: string;
		testPayer: TestPayerParams;
	}>({
		isWidget: false,
		handle: '',
		wgc: '',
		isIframe: false,
		testPayer: { firstName: '', lastName: '', emailAddress: '', mobileNumber: '' },
	});
	const [searchParams] = useSearchParams();
	useEffect(() => {
		const handle = searchParams.get(queryKeys.handle);
		const webGivingConfig = searchParams.get(queryKeys.wgc);
		const version = searchParams.get(queryKeys.version);
		const isIframe = [version].includes('iframe');
		setInfo({
			isIframe: [version].includes('iframe'),
			isWidget: !isIframe,
			handle: handle ?? '',
			wgc: webGivingConfig ?? '',
			testPayer: {
				firstName: searchParams.get(queryKeys.firstName) ?? '',
				lastName: searchParams.get(queryKeys.lastName) ?? '',
				emailAddress: searchParams.get(queryKeys.emailAddress) ?? '',
				mobileNumber: searchParams.get(queryKeys.mobileNumber) ?? '',
			},
		});
	}, [searchParams]);

	return info;
};
